import React, { useEffect, useMemo, useState } from 'react';
import Table from '../../../components/Tables/Schedule';
import { headerMaker } from '../../../components/Tables/Schedule/helper';
import Spinner from '../../../components/Spinner';
import { usePaginate } from 'hooks/usePaginate';
import { specialTasksHeader } from 'redux/modules/table/common';
import { Wrapper, Title, PageHeader } from './style';
import { Button } from 'antd';
import { useSelector } from 'react-redux';
import service from '../../../services/categories';
import workService from '../../../services/works';
import { useShowModal, useHideModal } from 'hooks/index';
import SpecialModal from './SpecialModal';

export default () => {
  const { showBlured } = useShowModal();
  const { hideModal } = useHideModal();
  const { data, handleOnTableChange, pageCount } = usePaginate();
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState([]);

  const { groups } = useSelector((state) => state.appReducer);

  const headers = useMemo(
    () => headerMaker(specialTasksHeader),
    [specialTasksHeader]
  );

  const fetchData = () => {
    setLoading(true);
    workService
      .getAllSpecialWorks()
      .then((resp) => {
        setReportData(resp);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    if (groups.length > 0) {
      fetchData();
    }
  }, []);

  const handleClickAddButton = () => {
    showBlured({
      title: 'Янги топшириқ яратиш',
      maxWidth: '600px',
      height: '400px',
      withHeader: false,
      body: () => (
        <SpecialModal groups={groups} handleClick={handleClickCreateTask} />
      ),
    });
  };

  const handleClickCreateTask = (data) => {
    const payload = {
      ...data,
      date: data.singleDate,
    };
    setLoading(true);
    service
      .createSpecial(payload)
      .then(() => {
        setLoading(false);
        hideModal();
        fetchData();
      })
      .catch((err) => console.log(err.message));
  };

  if (loading) return <Spinner maxHeight='100%' />;

  return (
    <Wrapper>
      <PageHeader>
        <Title>Топшириқлар рўйхати</Title>
        <Button
          type='primary'
          onClick={handleClickAddButton}
          style={{
            height: '40px',
            background: '#3380FF',
            borderRadius: '10px',
            padding: '0 10px',
          }}
        >
          Топшириқ яратиш
        </Button>
      </PageHeader>
      <Table
        headers={headers}
        data={data}
        onChange={handleOnTableChange}
        page={pageCount}
        reportsData={reportData}
        total={reportData.length}
      />
    </Wrapper>
  );
};
